import React from 'react'
import LinkAccountsSec from '../../components/organisms/link-account-section/link-account-section'

export const LinkAccounts = () => {
  return (
    <div className="dashboard">
      <div className="manage-account-container dashboard-inner-container">
        <LinkAccountsSec />
      </div>
    </div>
  )
}

export default LinkAccounts
